// plugins/leaflet.client.ts
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"

export default defineNuxtPlugin(() => {
  return {
    provide: {
      L: L,
    },
  }
})
